<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="title"
    :errors="{}"
  >
    <template v-slot:header>
    </template>
    <template v-slot:body>
      <ul v-if="users.length > 0">
        <li
          v-for="(users, idx) in users"
          :key="idx"
        >
          {{ users.text }}
          <img
            @click="removeUser"
            src="@/assets/icons/remove-students.svg"
            :data-index="idx"
          />
        </li>
      </ul>
      <div class="warning-no-student" v-if="users.length == 0">{{ $t('classes.create_class_flow.list_students_modal.warning_no_student') }}</div>
      <b v-if="noteConsent">{{noteConsent}}</b>
      <div class="actions">
        <primary-button
          @click.native="closeModal"
        >
          {{ $t('classes.create_class_flow.list_students_modal.got_it') }}
        </primary-button>
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'

  export default {
    components: {
      Modal,
      PrimaryButton
    },
    props: {
      users: {
        type: Array,
      },
      title: {
        type: String
      },
      warning: {
        type: String
      },
      noteConsent: {
        type: String
      }
    },
    methods: {
      closeModal() {
        this.$emit('closed')
      },
      removeUser(event) {
        const idx = event.target.attributes['data-index'].value
        this.users.splice(idx,1)
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog.elsa-modal {
    background-color: #F2F7FA;
  }
  ul {
    list-style: none;
    padding: 0;
    li {
      background: #F9FBFD;
      padding: 0 24px;
      margin-bottom: 4px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 55px;
      img {
        display: none;
      }
      &:hover img {
        display: block;
      }
    }
  }
  .actions {
    align-items: flex-start;
    .el-button {
      padding: 12px;
    }
  }
  .warning-no-student {
    color: #E6A23C;
    align-items: center;
    font-size: 16px;
  }

</style>
